export default "__VITE_ASSET__BraUMrm5__"